var _path, _path2, _path3, _rect, _ellipse, _path4, _ellipse2, _rect2, _path5, _path6, _path7, _path8, _ellipse3, _path9, _ellipse4, _path0, _ellipse5, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZaloPayActive = function SvgZaloPayActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5,
    d: "M4.75 10.5a.75.75 0 0 1 .75-.75h25.8a.75.75 0 0 1 .75.75v15.9a.75.75 0 0 1-.75.75H5.5a.75.75 0 0 1-.75-.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0084DD",
    fillRule: "evenodd",
    d: "M5.35 11.35a1 1 0 0 1 1-1h24.1a1 1 0 0 1 1 1v14.2a1 1 0 0 1-1 1H6.35a1 1 0 0 1-1-1z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.5 26.5 8.113 14.014a1 1 0 0 1 .903-1.107L30 11s1.31-.448 1.5.5v14.005a.996.996 0 0 1-1 .995z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 6,
    x: 13,
    y: 19,
    fill: "#00B523",
    rx: 1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.238,
    cy: 22.5,
    fill: "#FEFFFE",
    rx: 1.238,
    ry: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFFFE",
    d: "M18.875 21.375a.375.375 0 0 1 .75 0v2.25a.375.375 0 0 1-.75 0z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.313,
    cy: 22.5,
    fill: "#00B523",
    rx: 0.563,
    ry: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.8,
    height: 4,
    x: 14,
    y: 20,
    fill: "#fff",
    rx: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 20.5a.5.5 0 0 1 .5-.5h1.1a1.2 1.2 0 0 1 0 2.4H14z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B523",
    d: "M14.8 20.651h.708a.566.566 0 1 1 0 1.132H14.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFFFE",
    fillRule: "evenodd",
    d: "M20.393 21.034a.427.427 0 0 0-.228.559l.98 2.328-.207.484a.427.427 0 0 0 .785.336l1.344-3.14a.427.427 0 0 0-.785-.336l-.67 1.564-.66-1.567a.427.427 0 0 0-.559-.229",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0084DD",
    d: "M15 13h-3a.5.5 0 0 0 0 1h2l-2.4 3.2a.5.5 0 0 0 .4.8h3a.5.5 0 0 0 0-1h-2l2.4-3.2a.5.5 0 0 0-.4-.8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.65,
    cy: 16,
    fill: "#0084DD",
    rx: 1.65,
    ry: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0084DD",
    d: "M18.5 14.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.75,
    cy: 16,
    fill: "#fff",
    rx: 0.75,
    ry: 1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0084DD",
    d: "M20.5 13.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9,
    cy: 16,
    fill: "#0084DD",
    rx: 1.9,
    ry: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.85 16c0 .552-.414 1-.925 1-.51 0-.925-.448-.925-1s.414-1 .925-1c.51 0 .925.448.925 1"
  })));
};
export default SvgZaloPayActive;